import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=6496fa5d&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=6496fa5d&prod&lang=less&"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=6496fa5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496fa5d",
  null
  
)

export default component.exports